import { cn } from '@repo/videa-components/src/lib/utils';
import { useSelector } from 'react-redux';

import type { Appointment } from '../../../../react-query/useAppointments';
import { getDisplayName } from '../../../claims/shared/helpers';
import {
  type PatientListPageLayoutContext,
  PatientListPageLayoutContextMap,
} from '../../types';

export const AppointmentPatientNameGuard = ({
  appointment,
  index,
  context,
}: {
  appointment: Appointment;
  index: number;
  context?: PatientListPageLayoutContext;
}) => {
  const privacyOn = useSelector((state: any) => state.login?.user?.privacyOn);

  if (!appointment) {
    return null;
  }

  const { patientName, initials } = getDisplayName(appointment, index);

  const appointmentPrivateName = (
    <span
      className={cn(
        `vai-text-gray-700 vai-text-wrap vai-inline-flex vai-flex-wrap`,
        {
          'vai-font-semibold':
            context !== PatientListPageLayoutContextMap.Claims &&
            context !== PatientListPageLayoutContextMap.AutoVerify,
        },
      )}
      data-testid="patient-name"
      key={index}
    >
      {initials.map((initial: any, i) => (
        <div key={i} className="vai-inline-block">
          <span className="vai-inline-block">{initial}</span>
          <span
            className={cn(
              'vai-text-gray-300 vai-capitalize vai-blur-[5px] vai-select-none vai-text-xl vai-inline-block',
              {
                'vai-font-medium':
                  context !== PatientListPageLayoutContextMap.Claims &&
                  context !== PatientListPageLayoutContextMap.AutoVerify,
              },
            )}
          >
            &#x2588;&#x2588;&#x2588;
          </span>
        </div>
      ))}
    </span>
  );

  const appointmentPublicName = (
    <span
      className={cn(
        'vai-text-gray-900 vai-capitalize vai-break-words vai-text-left',
        {
          'vai-font-medium vai-text-xl':
            context !== PatientListPageLayoutContextMap.Claims &&
            context !== PatientListPageLayoutContextMap.AutoVerify,
        },
      )}
      data-testid="patient-name"
      key={index}
    >
      {patientName}
    </span>
  );

  return !privacyOn ? appointmentPrivateName : appointmentPublicName;
};
